// Chuẩn bị canvas vẽ SẮC NÉT trên màn hình DPI cao (Retina…).
// Đặt backing store = kích thước hiển thị × devicePixelRatio, rồi scale hệ toạ độ
// để code vẽ vẫn dùng toạ độ logic w×h nhưng render ở độ phân giải thiết bị → nét.
export function prepCanvas(
  canvas: HTMLCanvasElement | null,
  w: number,
  h: number
): CanvasRenderingContext2D | null {
  if (!canvas) return null
  const ctx = canvas.getContext('2d')
  if (!ctx) return null
  const dpr = Math.min(window.devicePixelRatio || 1, 2)
  const cw = canvas.clientWidth || w
  const ch = canvas.clientHeight || h
  // Pin kích thước hiển thị (CSS) 1 lần để việc đổi thuộc tính width/height (backing store)
  // không làm canvas phình to (với canvas không có CSS width như w-full).
  if (!canvas.style.width) { canvas.style.width = cw + 'px'; canvas.style.height = ch + 'px' }
  const bw = Math.max(1, Math.round(cw * dpr))
  const bh = Math.max(1, Math.round(ch * dpr))
  if (canvas.width !== bw || canvas.height !== bh) {
    canvas.width = bw
    canvas.height = bh
  }
  // map toạ độ logic (w×h) → backing (bw×bh)
  ctx.setTransform(bw / w, 0, 0, bh / h, 0, 0)
  ctx.clearRect(0, 0, w, h)
  return ctx
}
